const MAP = {
  uploaded: { label: "Uploaded", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  processing: { label: "Processing", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  failed: { label: "Failed", cls: "bg-red-100 text-red-800 border-red-200" },
};

export const StatusBadge = ({ status }) => {
  const s = MAP[status] || MAP.uploaded;
  return (
    <span
      data-testid="video-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      {(status === "processing" || status === "uploaded") && (
        <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" />
      )}
      {s.label}
    </span>
  );
};
